import React from "react"
import { StaticQuery, graphql } from "gatsby"

import WorksArchivedList from "../archivedlist"

const OthersContent = () => (
  <StaticQuery
    query = {graphql`
      query Others {
        allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "others-page"}}}, sort: {order: DESC, fields: frontmatter___date}) {
          edges {
            node {
              id
              html
              frontmatter {
                title
                date(formatString: "YYYY.MM.DD")
                tags
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `}
    render = {data => (
      <WorksArchivedList detail={data.allMarkdownRemark} keyword="others" />
    )}
  />
)

export default OthersContent